// Module
var code = `<div class="drawable">
	<div class="headline text-center">Service announcement</div>
	<div class="subheadline text-center">
		{{data.headline}}
	</div>
	<div class="body text-center">
		{{data.body}}
	</div>
</div>`;
// Exports
export default code;